document.addEventListener('readystatechange', function(event) {
  if (event.target.readyState === "complete") {
  const overlay = document.getElementById('custom-privacy-choices-overlay');
  const consentPopup = document.getElementById('custom-privacy-choices-popup');
  const saveConsentButton = document.getElementById('privacy-choices-save-consent');
  const closePopupButton = document.getElementById('privacy-choices-close-consent-popup');
  const cookieSettingsAnchors = document.querySelectorAll('a[href="#privacy-choices"]');
  const formId = document.getElementById('custom-privacy-choices-form-id');
  const submitButton = document.getElementById('custom-privacy-button-submit');
  let loaded = false;

  window.Shopify.loadFeatures(
   [
     {
       name: 'consent-tracking-api',
       version: '0.1',
     },
   ],
   error => {
     if (error) {
       console.log('we can no use consent settings from shopify');
     } else {   
        loaded = true;
        document.getElementById("privacy-choices-marketing-allowed").checked = window.Shopify.customerPrivacy.marketingAllowed();
     }
   },
  );

  if (consentPopup) {

    submitButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const form = document.getElementById(formId.value);
        console.log(form)
        const data = new URLSearchParams();
        for (const pair of new FormData(form)) {
            data.append(pair[0], pair[1]);
        }
        fetch(form.action, {
            method: 'post',
            body: data,
        })
        .then((response)=>{
          console.log(response)
        });
    });

   /* cookieSettingsAnchors.forEach(function(el){
      el.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        consentPopup.style.display = 'block';
        overlay.style.display = 'block';
        if(loaded) {
          document.getElementById("privacy-choices-marketing-allowed").checked = window.Shopify.customerPrivacy.marketingAllowed();
        }      
      });  
    })*/
      
  }
  
  if (saveConsentButton) {
    closePopupButton.addEventListener('click', function(){
      consentPopup.style.display = 'none';
      overlay.style.display = 'none';
    })
    saveConsentButton.addEventListener('click', function() {
      const consentOptions = {
        marketing: document.getElementById('privacy-choices-marketing-allowed').checked
      };
      window.Shopify.customerPrivacy.setTrackingConsent(
        consentOptions,
        () => {
          consentPopup.style.display = 'none';
          overlay.style.display = 'none';
        }
      );
    });
  }
}
});